import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import { PreloadDataFetchEnum } from '@am3nd-org/pointcraft-types';

import SelectCurrentDevice from 'src/utils/Providers/Guards/DeviceSelection/SelectCurrentDevice';

import { AuthGuard } from 'src/auth/guard';
import ErrorView from 'src/online-payment/components/ErrorView';
import PreloadDataGuard from 'src/auth/guard/preload-data-guard';
import SystemRequestGuard from 'src/auth/guard/system-request-guard';
import { ErrorBoundary } from 'src/online-payment/components/ErrorBoundary';
import CustomerPermissionGuard from 'src/auth/guard/customer-permission-guard';
import OnlinePaymentLayout from 'src/online-payment/layouts/OnlinePaymentLayout';
// ----------------------------------------------------------------------
const DashboardPage = lazy(() => import('src/online-payment/pages/dashboard'));
const TransactionsPage = lazy(() => import('src/online-payment/pages/transactions'));
const CustomersPage = lazy(() => import('src/online-payment/pages/customers'));
const SettingsPage = lazy(() => import('src/online-payment/pages/settings'));
const PaymentLinksPage = lazy(() => import('src/online-payment/pages/payment-links'));

// Common guard wrapper for both dashboard and v3 routes
const CommonGuardWrapper = ({ children }: { children: React.ReactNode }) => (
  <AuthGuard type="dashboard">
      <PreloadDataGuard type={[PreloadDataFetchEnum.USER_DATA, PreloadDataFetchEnum.DEVICES, PreloadDataFetchEnum.RECURRING_PLANS]}>
    <SelectCurrentDevice>
        <SystemRequestGuard>
          {children}
        </SystemRequestGuard>
    </SelectCurrentDevice>
      </PreloadDataGuard>
  </AuthGuard>
);
export const pointPayRoutes = [
  {
    path: 'online-payment',
    element: (
      <CommonGuardWrapper>
        <ErrorBoundary fallback={<ErrorView />}>
          <OnlinePaymentLayout>
            <Outlet />
          </OnlinePaymentLayout>
        </ErrorBoundary>
      </CommonGuardWrapper>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      // { path: 'dashboard', element: <DashboardPage /> },
      { path: 'transactions', element: <TransactionsPage /> },
      { path: 'payment-links', element: <PaymentLinksPage /> },
      {
        path: 'customers',
        element: (
          <CustomerPermissionGuard>
            <CustomersPage />
          </CustomerPermissionGuard>
        ),
      },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
];
